import * as React from 'react';
import type { TranslationFn } from '@mentimeter/question-modules-types';
import { TrashIcon, type IconT } from '@mentimeter/ragnar-visuals';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { IconButtonProps } from '@mentimeter/ragnar-ui/icon-button';
import { IconButton } from '@mentimeter/ragnar-ui/icon-button';

interface Props extends IconButtonProps {
  iconSize?: IconT['size'];
  selectedAnswer: string;
}

export const ModerationButton = ({ selectedAnswer, ...rest }: Props) => {
  const { useModeration, useTranslate } = usePresentationContext();
  const { showUi, toggleWord } = useModeration();
  const translate = useTranslate();

  return showUi && selectedAnswer ? (
    <ModerationButtonUI
      translateFn={translate}
      onClick={() => toggleWord(selectedAnswer)}
      {...rest}
    />
  ) : null;
};

interface UIProps extends IconButtonProps {
  iconSize?: IconT['size'];
  translateFn: TranslationFn;
}

export const ModerationButtonUI = ({
  translateFn,
  iconSize = 3,
  ...rest
}: UIProps) => {
  return (
    <IconButton
      size="large"
      variant="secondary"
      borderRadius="medium"
      bg="transparent"
      color="inherit"
      aria-label={translateFn('actions.delete_answer')}
      {...rest}
    >
      <TrashIcon size={iconSize} color="inherit" />
    </IconButton>
  );
};
